import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('task-queues', {
  library: 'task-queues'
});